module.exports = __webpack_public_path__ + "images/assessment.4f953402.webp";